<template>
    <div class="container f-s-b">
        <ul class="left-render-box">
            <li 
                v-touch:tap="onChangeActive(index)"
                v-for="(item, index) in leftList" :key="index"
                class="left-item g-b-500 "
                :class="index === active ? 'left-item-active theme-color-font':''"
            >{{item.name}}</li>
        </ul>
        <ul class="right-render-box">

            <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
            >

                <li 
                    v-for="(item, index) in productList" :key="index"
                    v-touch:tap="goToProductDetail(item)"
                    class="right-item f-s-b"
                >
                    <van-image 
                        class="product-image"
                        fit="cover"
                        lazy-load
                        :src="item.image"
                    />
                    <div class="product-info f-s-b">
                        <div class="product-name g-b-500 ellipsis2">{{item.name}}</div>
                        <div class="product-price ellipsis">¥{{item.price}}</div>
                        <van-image 
                            class="product-buy-btn"
                            lazy-load
                            :src="buyImage"
                        />
                    </div>
                </li>

            </van-list>

        </ul>
    </div>
</template>

<script>
    import { 
        List,
    } from 'vant';

    import {
        productSubTypeUrl,
        productListUrl,
    } from '@js/shoppingUrl.js';

    import http from '@js/http-hbt.js';

    export default {
        data() {
            return {
                active: 0,
                leftList: [
                    { 
                        name: '全部商品',
                    }, 
                    { 
                        name: '字画',
                    },
                    { 
                        name: '瓷器',
                    },
                    { 
                        name: '丝绸',
                    },
                    { 
                        name: '文房',
                    },
                    { 
                        name: '瓷器',
                    },
                    { 
                        name: '丝绸',
                    },
                    { 
                        name: '文房',
                    },
                ],
                productList:[],
                buyImage: require('@image/shopping/buy.png'),

                list: [],
                loading: false,
                finished: false,
                typeCode: "native",
                requestParams:{
                    offset:0,
                    psize: 20,
                    typeId: "",
                },
                isRequest: false,
            }
        },
        created() {
            this.productList = [];
            this.leftList = [];
            this.getProductSubType();
        },
        methods: {
            getProductSubType(){
                // this.$toast.loading({
                //     duration: 0,
                //     message: '加载中...',
                //     forbidClick: true,
                //     overlay: true,
                // });
                http.post(productSubTypeUrl,  { regCode: this.typeCode } )
                    .then(res=>{
                        var {
                            data: array
                        } = res;
                        this.leftList = [];
                        array.unshift({
                            type_name: "全部商品",
                            id: ""
                        })
                        array.map(item=>{
                            this.leftList.push({
                                name: item.type_name,
                                rawData: item
                            })
                        })
                    })
                    // .finally(()=>{
                    //     this.$toast.clear()
                    // })
            },
            getProductList(){
                if(this.isRequest) return;
                this.isRequest = true;
                http.post(productListUrl,{
                        type: this.typeCode,
                        orderRule: "all",
                        offset: this.productList.length,
                        psize: this.requestParams.psize,
                        isDesc: true,
                        typeId: this.requestParams.typeId,//..分类类型ID
                    },{
                        loading: false
                    }).then(res=>{
                        var {
                            data: array
                        } = res;
                        this.isRequest = false;
                        array.map(item=>{
                            this.productList.push({
                                image: this.getImagePrefix + item.COVER_URL,
                                name: item.NAME,
                                price: item.SELL_PRICE,
                                rawData: item,
                            })
                        })
                        this.loading = false;
                        if(array.length === 0 || this.productList.length < this.requestParams.psize ){
                            this.finished = true;
                        }
                    })
            },
            goToProductDetail(item) {
                return () => {
                    var {
                        rawData: {
                            ID: id
                        }
                    } = item;
                    this.$router.push({ name: 'productDetail', query: { id } })
                }
            },
            onChangeActive(index){
                return () => {
                    if(this.active === index) return;
                    var {
                        rawData: {
                            id = ""
                        }
                    } = this.leftList[index];
                    this.requestParams.typeId = id;
                    this.active = index;
                    this.productList = [];
                    this.finished = false; 
                    this.getProductList();
                }
            },
            onLoad() {
                this.getProductList();
                // 异步更新数据
                // setTimeout 仅做示例，真实场景中一般为 ajax 请求
                // setTimeout(() => {
                //     // for (let i = 0; i < 10; i++) {
                //     //     this.list.push(this.list.length + 1);
                //     // }
                //     // this.randomList();
                //     this.getProductList();
                //     // 加载状态结束
                //     this.loading = false;
                //     // 数据全部加载完成
                //     // if (this.list.length >= 60) {
                //     //     this.finished = true;
                //     // }
                //     if (this.productList.length >= 60) {
                //         this.finished = true;
                //     }
                // }, 1000);
            },
            randomList(){
                var productList = [
                        {
                            image: require('@image/shopping/45.png'),
                            name: '雍正珐琅彩花瓶',
                            price: '67.80',
                        },
                        {
                            image: require('@image/shopping/34.png'),
                            name: '雍正珐琅彩花瓶',
                            price: '67.80',
                        },
                        {
                            image: require('@image/shopping/89.png'),
                            name: '雍正珐琅彩花瓶',
                            price: '67.80',
                        },
                        {
                            image: require('@image/shopping/688.png'),
                            name: '雍正珐琅彩花瓶',
                            price: '67.80',
                        },
                        {
                            image: require('@image/shopping/4555.png'),
                            name: '雍正珐琅彩花瓶',
                            price: '67.80',
                        },
                    ]
                for (let index = 0; index < (parseInt(Math.random()*10) + 20); index++) {
                    var tempIndex = parseInt(Math.random()*5);
                    this.productList.push(productList[tempIndex]);
                }
            },
        },
        computed: {
            getImagePrefix(){
                return this.$store.state.shoppingBlock.bgImgPrefix || "";
            }
        },
        components: {
            [List.name]: List,
        }
    }
</script>

<style lang="less" scoped>
    @import "./style/home-public-style.less";
    .container{
        .left-render-box,
        .right-render-box{
            height: 100%;
            box-sizing: border-box;
            overflow-y: scroll;
            &::-webkit-scrollbar {display:none}
        }
        @leftWidth:80px;
        .left-render-box{
            width: @leftWidth;
            font-size: 12px;
            overflow-y: scroll;
            background-color: #ffffff;
            .left-item{
                background-color: #E2E2E2;
                transition: all .3s ease;
                text-align: center;
                padding: 16px 24px;
                // margin-bottom: 1px;
                border-bottom: 1px solid #ffffff;
                position: relative;
                &::before{
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    bottom: 0;
                    width:0px;
                    background:rgba(71,148,255,1);
                    transition: all .3s ease;
                }
                &:last-child{
                    margin: 0;
                    border: 0;
                }
            }
            .left-item-active{
                &::before{
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    bottom: 0;
                    width:4px;
                    background:rgba(71,148,255,1);
                    // background:linear-gradient(157deg,rgba(255,163,0,1) 0%,rgba(255,63,54,1) 100%);
                    transition: all .3s ease;
                }
            }
        }
        .right-render-box{
            // flex: 1;
            padding: 10px;
            width: calc(~"100% - @{leftWidth}");
            font-size: 13px;
            background:rgba(255,255,255,1);
            .right-item{
                margin-bottom: 10px;
                padding: 12px 8px;
                @imageWidth:108px;
                background:rgba(255,255,255,1);
                box-shadow:0px 1px 8px 0px rgba(212,206,218,0.5);
                border-radius:5px;
                &:last-of-type{
                    margin: 0;
                }
                .product-image{
                    width:@imageWidth;
                    height:66px;
                    border-radius:10px;
                    overflow: hidden;
                }
                .product-info{
                    padding-left: 12px;
                    box-sizing: border-box;
                    width: calc(~'100% - @{imageWidth}');
                    height:66px;
                    align-items: flex-start;
                    position: relative;
                    flex-direction: column;
                    .product-name{
                        color: #353A3E;
                        width: 100%;
                    }
                    .product-price{
                        width: 100%;
                        color: #FF5131;
                        font-weight: 600;
                        word-break: break-word;
                        width: ~'calc(100% - 24px)';
                    }
                    .product-buy-btn{
                        position: absolute;
                        bottom: 0;
                        right: 0;
                        width:25px;
                        height:25px;
                        border-radius: 100%;
                        overflow: hidden;
                    }
                }
            }
        }
    }
</style>